import(/* webpackMode: "eager" */ "/app/src/app/(app)/error.tsx");
